import { addTruthyParamsToUrl, urlWithNext } from "@zapier/url-utils";

import { getPathName, redirectTo } from "./helpers";

const redirectToLogin = () => {
  const reauthUrl = addTruthyParamsToUrl(
    urlWithNext("/app/login", getPathName()),
    {
      reauth: true,
    }
  );
  redirectTo(reauthUrl);
};

export { redirectToLogin };
